import { interpretStripeCardError } from './payments';

export const confirm3dsPayment = async (stripe, clientSecret) => {
    const { error } = await stripe.confirmCardPayment(clientSecret);
    if (error) {
        return { errorMessage: interpretStripeCardError(error) };
    }
    return null;
};
